import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { mileageRatePresetRepository } from '../data-access/repositories/MileageRatePresetRepository'

const base = ['mileage-rate-preset']

export const mileageRatePresetQueryConfig = {
  list: () => ({
    queryKey: buildQueryKey([...base, 'list']),
    queryFn: () => mileageRatePresetRepository.list(),
  }),
  detail: (id: number) => ({
    queryKey: buildQueryKey([...base, id]),
    queryFn: () => mileageRatePresetRepository.getMileageRatePreset(id),
  }),
}
